// dev and qa
// export const REACT_APP_API_URL = "https://dev.dynamicwebsite.co.in/ab/gps/qa/api/";

// Stage
// export const REACT_APP_API_URL =
//   "https://dev.dynamicwebsite.co.in/ab/gps/stage/api/";

// New QA

// export const REACT_APP_API_URL =
//   "https://testserv.dynamicwebsite.co.in/ab/gps/dev/api/";

  // export const REACT_APP_API_URL =
  // "http://localhost:8000/api/";
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL
  || (() => { throw new Error('REACT_APP_API_URL environment variable is not set'); })();

// Production
// export const REACT_APP_API_URL = "https://globalparkingservices.com/adminmanager/api/";

// export const REACT_APP_API_URL = "http://34.193.221.44/api/";
// export const REACT_APP_API_URL = "http://34.193.221.44/adminmanager/api/";
// export const REACT_APP_API_URL = "http://34.195.105.216/adminmanager/api/";
// export const REACT_APP_API_URL = "https://globalparkingservices.com/adminmanager/api/";


export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY
  || (() => { throw new Error('REACT_APP_API_KEY environment variable is not set'); })();
